<app-dialog (closeEvent)="onClose()"
  [manualCloseManagement]="true"
  [dialogWithInput]="dialog">
  <app-create-update-default #createUpdateDefaultComponent
                             [formGroup]="formGroup"
                             [id]="id"
                             [buildPayload]="buildPayload"
                             (entitySaved)="entitySaved($event)"
                             (entityLoaded)="entityLoaded($event)"
                             [findOneService]="findOneService"
                             [dontGoBakOnSaveSuccess]="true"
                             [service]="saveService"
                             [hideSaveButton]="true">
    <ng-template template-content>
        <app-card title="Informations générales">
            <div class="row">
                <app-form-field
                        [required]="true"
                        label="Libellé">
                    <app-input-text
                            [parentFormGroup]="formGroup"
                            parentFormControlName="label"></app-input-text>
                </app-form-field>
                <app-form-field [required]="true"
                                label="Type">
                    <app-lov-value-select-filter [parentFormGroup]="formGroup"
                                                 parentFormControlName="typeValue"
                                                 lovListName="COMMUNICATION_CONTENT_MODEL_TYPE">
                    </app-lov-value-select-filter>
                </app-form-field>
                <app-form-field label="Actif">
                    <app-checkbox-input [parentFormGroup]="formGroup" parentFormControlName="active"></app-checkbox-input>
                </app-form-field>
            </div>
        </app-card>
        <app-card title="Contenu">
            <div class="row">
                <app-form-field label="Expressions" [size]="12" [sizeLg]="3" [sizeXl]="3">
                    <div style="max-height: 400px; overflow-y: scroll;">
                        <app-loading [loading]="substitutionService.loading$ | async" [showText]="false"></app-loading>
                        <app-error-text [error]="error" *ngIf="(substitutionService.error$ | async) as error" message="Chargement des expressions dynamiques impossible"></app-error-text>
                        <ng-container *ngFor="let cat of substitutionCategories">
                            <h5>{{cat.label}}</h5>
                            <app-button
                                    style="display: block; overflow: hidden;"
                                    class="m-y-4"
                                    fill="solid"
                                    iconName="plus"
                                    [tooltip]="substitution.name"
                                    [label]="substitution.name"
                                    (clickEvent)="substitutionClicked(substitution)"
                                    *ngFor="let substitution of cat.substitutions"></app-button>
                        </ng-container>
                    </div>
                </app-form-field>
                <app-form-field label="Contenu" [size]="12" [sizeLg]="9" [sizeXl]="9">
                    <app-rich-text-editor #richTextEditorComponent [parentFormGroup]="formGroup" parentFormControlName="content"></app-rich-text-editor>
                </app-form-field>
            </div>
        </app-card>
    </ng-template>
  </app-create-update-default>

  <ng-container dialog-actions>
    <app-loading [loading]="createUpdateDefaultComponent.saveLoading" [showText]="false"></app-loading>
    <app-button (click)="executeSave()" [disabled]="!formGroup.valid" fill="solid"
                iconName="check" label="Enregistrer" *ngIf="!createUpdateDefaultComponent.saveLoading &&
                !createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError"></app-button>
  </ng-container>
</app-dialog>
